import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Container } from '@scentregroup/ui'
import Menu from '../menu'
import Search from '../search'
import style from './index.module.scss'
import { NavigationMenuType } from './types'

let headerStyle = classNames(style.stickHeader, style.header)

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: props.searchQuery,
    }
  }

  setWrapper = ref => {
    this.wrapper = ref
  }

  render() {
    const { navigationMenu } = this.props
    return (
      <header
        ref={this.setWrapper}
        className={classNames(headerStyle, style.header)}
      >
        <Container className={style.container} type="large">
          <div className={style.menuWrap}>
            {navigationMenu && <Menu navigationMenu={navigationMenu} />}

            <Search
              placeholder={'Search products'}
              history={this.props.history}
              className={style.searchForm}
              searchQuery={this.state.searchQuery}
            />
          </div>
        </Container>
      </header>
    )
  }
}

Header.propTypes = {
  navigationMenu: NavigationMenuType,
  history: PropTypes.object,
  searchQuery: PropTypes.string,
}

export default Header
